import { useCallback } from 'react'

import { useSearchParams } from 'react-router-dom'

import { ContentModuleType } from '@tribeplatform/gql-client/types'

import {
  CONTENT_MODULE_ID_QUERY_PARAM,
  CONTENT_MODULE_TYPE_QUERY_PARAM,
} from '../constants/content-module.js'

import { useQueryParam } from './useQueryParam.js'

export const useActiveContentModuleModal = () => {
  const [, setSearchParams] = useSearchParams()
  const [contentType] = useQueryParam<ContentModuleType>({
    name: CONTENT_MODULE_TYPE_QUERY_PARAM,
  })
  const [contentId] = useQueryParam<string>({
    name: CONTENT_MODULE_ID_QUERY_PARAM,
  })

  const setActiveContentModule = useCallback(
    (contentType: ContentModuleType, id: string) => {
      setSearchParams(prev => {
        const params = new URLSearchParams(prev)
        params.set(CONTENT_MODULE_TYPE_QUERY_PARAM, contentType)
        params.set(CONTENT_MODULE_ID_QUERY_PARAM, id)
        return params
      })
    },
    [setSearchParams],
  )

  const clearActiveContentModule = useCallback(() => {
    setSearchParams(prev => {
      const params = new URLSearchParams(prev)
      params.delete(CONTENT_MODULE_TYPE_QUERY_PARAM)
      params.delete(CONTENT_MODULE_ID_QUERY_PARAM)
      return params
    })
  }, [setSearchParams])

  return {
    contentType,
    contentId,
    setActiveContentModule,
    clearActiveContentModule,
  }
}
